
import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import {withStyles} from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'


const styles = theme => ({
  optionIndex: {
    color: theme.palette.secondary.main,
    fontSize: '1.75rem',
    fontWeight: 'bolder',
    marginRight: 10,
  },
  optionPaneLeft: {paddingRight: theme.spacing.unit * 3},
  optionPaneRight: {
    borderLeft: `1px solid ${theme.palette.action.disabled}`,
    paddingLeft: theme.spacing.unit * 3
  },
  optionPane: {marginTop: 50}
})

class SelectedDecisionContainer extends Component {
  constructor(props) {
    super(props)
    this.props.navigator.hideBackButton()
    this.props.navigator.setForwardButtonLabel('Continue Session')
    this.props.navigator.withProgressBar(false)
  }

  renderOptionsPanes() {
    const {classes, options, t} = this.props
    return options.map((option, index) => {
      const paneClasses = `
        ${classes.optionPane} 
        ${index === 0 ? classes.optionPaneLeft : classes.optionPaneRight}
      `
      return (
        <Grid item xs={6} className={paneClasses} key={option}>
          <Typography variant="title" style={{marginBottom: 15}}>{t('Option', {OPTIONNUM: (index+1)})}</Typography>
          <Typography variant="subheading">
            {option}
          </Typography>
        </Grid>
      )
    })
  }

  render() {
    const {t} = this.props
    return (
      <Grid
        alignContent="flex-start"
        className="counseling-session-page-container"
        container
        justify="center"
        spacing={8}
      >
        <Grid item xs={10}>
          <Typography variant="title">{t('Selected Decision')}</Typography>
        </Grid>
        <Grid item xs={10}>
          <Typography variant="headline" style={{fontWeight: 'lighter'}}>
            {this.props.decisionName}
          </Typography>
        </Grid>
        <Grid
          container
          item
          justify="center"
          xs={10}
        >
          {this.renderOptionsPanes()}
        </Grid>
      </Grid>
    )
  }
}

const mapStateToProps = state => ({
  decisionName: state.counselingSession.counselingSessionData.decisionName,
  options: state.counselingSession.counselingSessionData.options,
})

export default compose(
  withStyles(styles),
  translate(),
  connect(mapStateToProps)
)(SelectedDecisionContainer)


// WEBPACK FOOTER //
// ./src/components/counseling-session/selected-decision/SelectedDecisionContainer.js